export { BkLogoPrimary } from './BKLogoPrimary';
export { BkLogoRoyalPerks } from './BKLogoRoyalPerks';
export { BkLogoRoyalPerksFR } from './BKLogoRoyalPerksFR';
export { BkLogoSecondary } from './BKLogoSecondary';
